import { reducers } from '@smorder/logic';

import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { seamlessImmutableReconciler, seamlessImmutableTransformCreator } from 'redux-persist-seamless-immutable';

import notificationReducer from './notification.reducers';
import navigatorReducer from './navigator.reducers';
import orderReducer from './order.reducers';
import appReducer from './app.reducers';
import alertReducer from './alert.reducers';
import signageReducer from './signage.reducers';
import menuReducer from './menu.reducers';

const transformerConfig = {
  whitelistPerReducer: {
    orders: ['orderhistory', 'routestops', 'printingorders'],
    app: ['localSettings'],
  },
  blacklistPerReducer: {
    authentication: ['errorMessage', 'loading'],
  },
};

export const rootPersistConfig = {
  key: 'root-waiter',
  storage,
  whitelist: ['orders', 'authentication', 'app'],
  stateReconciler: seamlessImmutableReconciler,
  transforms: [seamlessImmutableTransformCreator(transformerConfig)],
};

const combinedRootReducer = combineReducers({
  ...reducers,
  notification: notificationReducer,
  navigator: navigatorReducer,
  orders: orderReducer,
  app: appReducer,
  alert: alertReducer,
  signage: signageReducer,
  menu: menuReducer,
});

export default persistReducer(rootPersistConfig, combinedRootReducer);
